
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/l/[country]",
      function () {
        return require("private-next-pages/l/[country].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/l/[country]"])
      });
    }
  